import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Col from "@bappweb/col"
import Row from "@bappweb/row"
import "../assets/style.scss"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Row>
        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
          <div className="bapp-container">
            <Block className="landing-header-text-wrapper">
              <Block className="landing-header-text">
                <Element type="h1" className="header-text1">
                  {
                    "Hayata Devam Sigortası, toplam 13 tehlikeli hastalık durumunda finansal akışına destek olmak için yanında."
                  }
                </Element>
                <Element type="p" className="header-text2">
                  {
                    "Hayata devam sigortası ile hastalığınızla ilgili tedavi masraflarınızı karşılayabilir ya da çalışmaya ara vermek zorunda kalmanız halinde kendinizi ve ailenizi daha güvende hissetmek için finansal destek sağlayabilirsiniz. Üstelik ücretsiz check-up, online sağlık danışmanlığı gibi hizmetlerden poliçeniz süresince faydalanabilirsiniz."
                  }
                </Element>
              </Block>
            </Block>

            <Image path={"./img/hayatadevamlead/hayata-devam-sigorta.png"} className="landing-header-img" />
          </div>
        </Col>
      </Row>
    </Block>
  )
}

export default LandingHeader
